/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import {
  REGIONDATA_LOAD,
  REGIONDATA_LOAD_FAILURE,
  REGIONDATA_LOAD_SUCCESS,
} from "Constants/ActionTypes";
import { IRegionData } from "Interfaces/SiteContent";

/**
 * Interface for getting
 * a CL Region.
 * @interface
 */
export interface IGetRegion {
  type: typeof REGIONDATA_LOAD;
}

/**
 * Interface for getting
 * a CL Region successfully.
 * @interface
 */

export interface IGetRegionSuccess {
  type: typeof REGIONDATA_LOAD_SUCCESS;
  regions: IRegionData[];
}

/**
 * Interface for the failure
 * to get a CL region.
 * @interface
 */

export interface IGetRegionFailure {
  type: typeof REGIONDATA_LOAD_FAILURE;
  regionLoadError: string;
}

/**
 * Action creator for REGIONDATA_LOAD.
 */
export const getRegion = (): RegionActionTypes => ({
  type: REGIONDATA_LOAD,
});

/**
 * Action creator for REGIONDATA_LOAD_SUCCESS.
 * @param regions the CL regions successfully loaded.
 */
export const getRegionSuccess = (regions: IRegionData[]): RegionActionTypes => ({
  type: REGIONDATA_LOAD_SUCCESS,
  regions,
});

/**
 * Action creator for REGIONDATA_LOAD_FAILURE.
 * @param errorMessage the error message from the server.
 */
export const getRegionFailure = (regionLoadError: string): RegionActionTypes => ({
  type: REGIONDATA_LOAD_FAILURE,
  regionLoadError,
});

export type RegionActionTypes = IGetRegion | IGetRegionSuccess | IGetRegionFailure;
